export const getGunsList =  (wqlist: Array<any> = []) => {
  const res: Array<any> = [];

  wqlist.forEach((item: any, index: number) => {
    item.lxB5[0].dx2a.forEach((subItem: any, subIndex: number) => {
      // 判断当前武器是否有详情和判断是否为近战武器
      if (subItem.wqxqF9 && subItem.wqid75.indexOf(108) < 0) {
        subItem.index = index;
        subItem.subIndex = subIndex;
        res.push(subItem);
      }
    });
  });

  return res;
};
